module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/statement6/statement6.component.scss
// module id = ./src/app/statement6/statement6.component.scss
// module chunks = main